import { isUndefined } from '@aloft/toolkit-shared';

import { useEffect, useState } from 'react';

import { makeStreetViewStaticURL } from './makeStreetViewStaticURL.ts';
import { useLatLngFromAddress } from './useLatLngFromAddress.ts';

export const useStreetViewStaticUrl = (
  address: string | undefined,
  passedPosition: { lat?: number; lng?: number },
  shouldGetUrl: boolean,
): string => {
  const [url, setUrl] = useState<string>('');
  const { latLng, status } = useLatLngFromAddress(address, shouldGetUrl);

  useEffect(() => {
    if (shouldGetUrl) {
      if (status === 'pending') {
        setUrl('');
        return;
      }

      if (isUndefined(latLng)) {
        // got position, but wasn't a thing

        if (isUndefined(passedPosition.lat) || isUndefined(passedPosition.lng)) {
          setUrl(''); // no passed position, no geocoded position
          return;
        }

        // no geocode version, yes passed version
        setUrl(makeStreetViewStaticURL(passedPosition.lat, passedPosition.lng));
        return;
      }

      setUrl(makeStreetViewStaticURL(latLng.lat, latLng.lng));
    }
  }, [latLng, passedPosition.lat, passedPosition.lng, shouldGetUrl, status]);

  return url;
};
